export const Header = () => {
  return (
    <div className="w-full sticky-header py-2 font-light text-xs text-white bg-gradient-to-r from-red-900 to-gray-800 z-10">
      <div className="container">
        <div className="marquee-wrapper overflow-hidden">
          <div className="animate-marquee-wrapper flex">
            {/* Baris 1 */}
            <div className="animate-marquee whitespace-nowrap animate-marquee-1">
              Jakarta Open Trail Run (JOTR) Cianjur Series 2026 · The Official
              Southeast Asia Trail Running Cup (SEATRC) · "Trail for Glory, From
              Jakarta to the Peak" – 2nd Edition · 27 September 2026 · Cibodas
              Botanical Garden, Indonesia
            </div>

            {/* Baris 2 – mulai setelah baris 1 lewat */}
            <div className="animate-marquee whitespace-nowrap animate-marquee-2 ml-96">
              Indonesia proudly hosts the inaugural SEATRC 2026 · Bringing
              together the best trail runners from across Southeast Asia ·
              Categories from 10K to Ultra-Endurance · World-class trails
              through alpine botanical gardens and lush mountain vegetation ·
              Promoting sport tourism, nature conservation, and the growth of
              trail running culture in the region
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
